import classNames from 'classnames'
import {
  MdCheckCircleOutline,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdNotInterested,
  MdOutlineAccessTime,
} from 'react-icons/md'

import type { ReactElement } from 'react'

import Button from '~/components/Buttons/Button'
import Team from '~/components/Team'
import UserCard from '~/components/UserCard'

import './styles.scss'

const REGEX =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm

interface Props {
  belongsToTeam: boolean
  current?: boolean
  description?: string
  isDone?: boolean
  isOpen?: boolean
  isSkipped?: boolean
  name: string
  onDone: VoidFunction
  onSkip: VoidFunction
  onToggle: VoidFunction
  teamName: string
  updatedBy?: {
    date: string
    name: string
    picture?: string
  }
  users: {
    job?: string
    name: string
    picture?: string
  }[]
}

/**
 * @deprecated Could be safely removed when Checklists are fully migrated to the new Todolist
 * Then rename TooltipCollapsibleCard to CollapsibleCard
 */
const CollapsibleCard = ({
  belongsToTeam,
  current,
  description,
  isDone,
  isOpen,
  isSkipped,
  name,
  onDone,
  onSkip,
  onToggle,
  teamName,
  updatedBy,
  users,
}: Props): ReactElement => {
  /** Local state */

  const collapseCardClasses = classNames('collapsible-card-wrapper', {
    collapsed: !isOpen,
    current,
    done: isDone,
    skipped: isSkipped,
  })

  const collapseCardMainContentClasses = classNames('collapsible-card-main-content', { collapsed: !isOpen })

  const formattedDescription = description?.split(' ').map((word) => {
    return word.match(REGEX) ? (
      <>
        <a className="inner-link" href={word} rel="noreferrer" target="_blank">
          {word}
        </a>{' '}
      </>
    ) : (
      word + ' '
    )
  })

  /** Render */

  return (
    <div className={collapseCardClasses}>
      <div className="collapsible-card-wrapper-content">
        <div className="collapsible-card-header">
          <div className="title-container">
            <div className="title-content">
              <div className="card-header-title">{name}</div>
              {formattedDescription ? <div className="card-header-subtitle">{formattedDescription}</div> : null}
            </div>
            {isDone ? (
              <MdCheckCircleOutline color="#3aaf4b" size={22} />
            ) : isSkipped ? (
              <MdNotInterested size={22} />
            ) : current ? (
              <MdOutlineAccessTime size={22} />
            ) : null}
          </div>
        </div>
        <div className={collapseCardMainContentClasses}>
          <Team label={teamName} size="small" users={users} />
          {current && !isDone && !isSkipped && belongsToTeam ? (
            <div className="button-wrapper">
              {!isSkipped ? (
                <Button className="button" ghost onClick={onSkip} size="small">
                  Skip
                </Button>
              ) : null}
              <Button className="button" onClick={onDone} size="small">
                Done
              </Button>
            </div>
          ) : null}
          {(isDone || isSkipped) && updatedBy ? (
            <div className="button-wrapper">
              <div className="user-card-container">
                <UserCard
                  label={isDone ? 'Done by' : isSkipped ? 'Skipped by' : ''}
                  labelPosition="left"
                  name={updatedBy.name}
                  picture={updatedBy.picture}
                  size="small"
                  subInfo={updatedBy.date}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className="collapse-icon" onClick={onToggle}>
        {isOpen ? <MdKeyboardArrowUp color="#626262" size={20} /> : <MdKeyboardArrowDown color="#626262" size={20} />}
      </div>
    </div>
  )
}

export default CollapsibleCard
